import { Suspense, lazy } from "react";
import { Toaster } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { Routes, Route } from "react-router-dom";
import { ErrorBoundary } from "@/components/ErrorBoundary";

// Lazy load components for better performance
const BookingRouter = lazy(() => import("@/components/booking/BookingRouter"));
const BookingSuccessPage = lazy(() => import("@/components/booking/BookingSuccessPage"));
const MarketingConsentVerification = lazy(() => import("@/components/MarketingConsentVerification"));
const VisitManagement = lazy(() => import("@/components/managing/VisitManagement").then(module => ({ default: module.default })));
const WithdrawalPage = lazy(() => import("@/components/managing/WithdrawalPage").then(module => ({ default: module.default })));

const App = () => (
  <ErrorBoundary>
    <TooltipProvider>
      <Toaster />
      <Routes>
        {/* Customer booking routes */}
        <Route path="/book/success" element={
          <Suspense fallback={null}>
            <BookingSuccessPage />
          </Suspense>
        } />
        <Route path="/book/:tenantSlug" element={
          <Suspense fallback={null}>
            <BookingRouter type="studio" />
          </Suspense>
        } />
        <Route path="/book/:tenantSlug/member/:memberSlug" element={
          <Suspense fallback={null}>
            <BookingRouter type="member" />
          </Suspense>
        } />
        <Route path="/book/:tenantSlug/service/:serviceSlug" element={
          <Suspense fallback={null}>
            <BookingRouter type="service" />
          </Suspense>
        } />
        <Route path="/book/:tenantSlug/success" element={
          <Suspense fallback={null}>
            <BookingSuccessPage />
          </Suspense>
        } />

        {/* Standalone routes */}
        <Route path="/verify-marketing-consent" element={
          <Suspense fallback={null}>
            <MarketingConsentVerification />
          </Suspense>
        } />
        <Route path="/manage" element={
          <Suspense fallback={null}>
            <VisitManagement />
          </Suspense>
        } />
        <Route path="/widerruf" element={
          <Suspense fallback={null}>
            <WithdrawalPage />
          </Suspense>
        } />

        {/* Default route for development */}
        <Route path="/" element={
          <div className="flex items-center justify-center min-h-screen">
            <div className="text-center">
              <img
                src="http://localhost:8080/sylva-platform-logo.svg"
                alt="Sylva Platform"
                className="h-16 mx-auto mb-6"
              />
              <a
                href="https://www.getsylva.de/"
                className="text-primary hover:underline font-medium"
              >
                Jetzt mehr erfahren
              </a>
            </div>
          </div>
        } />

        {/* Catch-all route */}
        <Route path="*" element={
          <div className="flex items-center justify-center min-h-screen">
            <h1 className="text-2xl">Page Not Found</h1>
          </div>
        } />
      </Routes>
    </TooltipProvider>
  </ErrorBoundary>
);

export default App;
